module.exports = __webpack_public_path__ + "img/HomeEDC5000.0e9b85ca.jpg";